import React from "react";
import { useTranslation } from "react-i18next";
import { useThemeStore } from "@/stores/useThemeStore";

export type Theme = "dark" | "light" | "system";

const themes: { id: Theme; labelKey: string; icon: string }[] = [
  { id: "dark", labelKey: "shared.themeDark", icon: "🌙" },
  { id: "light", labelKey: "shared.themeLight", icon: "☀️" },
  { id: "system", labelKey: "shared.themeSystem", icon: "💻" },
];

export default function ThemeToggle({ compact = false }: { compact?: boolean }) {
  const { t } = useTranslation();
  const theme = useThemeStore((s) => s.systemTheme);
  const setSystemTheme = useThemeStore((s) => s.setSystemTheme);

  if (compact) {
    return (
      <div style={{ display: "flex", gap: 4 }}>
        {themes.map((th) => (
          <button
            key={th.id}
            onClick={() => setSystemTheme(th.id)}
            title={t(th.labelKey)}
            style={{
              width: 32,
              height: 32,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "var(--radius-sm)",
              border: `2px solid ${theme === th.id ? "hsl(var(--primary))" : "hsl(var(--border))"}`,
              background: theme === th.id ? "hsl(var(--primary) / 0.2)" : "hsl(var(--bg3))",
              color: "hsl(var(--foreground))",
              cursor: "pointer",
              fontSize: 14,
            }}
          >
            {th.icon}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div style={{ display: "flex", gap: 8 }}>
      {themes.map((th) => (
        <button
          key={th.id}
          onClick={() => setSystemTheme(th.id)}
          style={{
            padding: "8px 14px",
            borderRadius: "var(--radius-sm)",
            border: `2px solid ${theme === th.id ? "hsl(var(--primary))" : "hsl(var(--border))"}`,
            background: theme === th.id ? "hsl(var(--primary) / 0.2)" : "hsl(var(--bg3))",
            color: "hsl(var(--foreground))",
            fontFamily: "DM Sans, sans-serif",
            fontSize: 13,
            cursor: "pointer",
          }}
        >
          {th.icon} {t(th.labelKey)}
        </button>
      ))}
    </div>
  );
}
